import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Catalog, Regimen } from '@cureskin/api-client/src/server-api';
import { SwiperModule } from 'swiper/angular';
import { ProductComponent } from '../product/product.component';
import { ProductSize } from '../product/product.types';
import { BuyCompleteKitBannerComponent } from '../buy-complete-kit-banner/buy-complete-kit-banner.component';
import { RegimenClass } from '../../unpaid-user-shop/unpaid-user-shop.types';

@Component({
  selector: 'app-regimen-products-list',
  imports: [ProductComponent, BuyCompleteKitBannerComponent, SwiperModule],
  templateUrl: './regimen-products-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegimenProductsListComponent {
  readonly ProductSize = ProductSize;
  readonly RegimenClass = RegimenClass;
  products = input<Array<Catalog & { isLocked?: boolean }>>([]);
  userName = input<string>('');
  userPhoto = input<string>('');
  productsInCart = input<{ [key: string]: number }>({});
  regimens = input<Regimen[]>([]);
  activeRegimenClass = input<RegimenClass>();

  renderBullet = (index: number, className: string): string => `<span class="${className}"></span>`;

  addToCart = output<{ product: Catalog; image: HTMLImageElement }>();
  removeFromCart = output<Catalog>();
  buyKit = output<Regimen>();
  gotoProduct = output<Catalog>();

  onAddToCart(event: { product: Catalog; image: HTMLImageElement }): void {
    this.addToCart.emit(event);
  }

  onRemoveFromCart(product: Catalog): void {
    this.removeFromCart.emit(product);
  }

  onBuyKit(regimen: Regimen): void {
    this.buyKit.emit(regimen);
  }

  onGotoProduct(product: Catalog): void {
    this.gotoProduct.emit(product);
  }
}
